export const fieldsToDroppedFieldsMapper = (fields,droppedFields) => {
  const valueMap = (fields || []).reduce(
    (acc, { id, value }) => {
      acc[id] = value;
      return acc;
    },
    {},
  );

  const mappedFields = Object.fromEntries(
    Object.entries(droppedFields || {}).map(
      ([page, fieldArray]) => [
        page,
        fieldArray.map((field) => ({
          ...field,
          value: valueMap[field.id] ?? field.value,
        })),
      ],
    ),
  );
  return mappedFields;
};